const Marionette = require('lib/marionette')
const Router = require('lib/router')
const Verify = require('module/verify/verify')
const log = require('log').create('profile', 'router') // eslint-disable-line

const ProfileRouter = Marionette.MnObject.extend({

    initialize(options) {
        this.user = options.user

        this.router = new Router({
            controller: this,
            scope: this.user.get('user_name'),
            appRoutes: {
                'verify(/)(*params)': 'handleVerification',
            },
        })
    },

    handleVerification() {
        this.verification = new Verify({
            user: this.user,
        })

        this.listenTo(this.verification, 'destroy', () => {
            this.router.navigate('', { replace: true, force: true })
        })
    },

})

module.exports = ProfileRouter
